export default [
    {
        path: '/',
        redirect: '/dashboard'
    },
    {
        path: '*',
        redirect: 'error-404'
    }
]



// WEBPACK FOOTER //
// ./src/router/root.js